import { render } from "./cwzb.vue?vue&type=template&id=7b6df4a3&scoped=true&ts=true"
import script from "./cwzb.vue?vue&type=script&lang=ts"
export * from "./cwzb.vue?vue&type=script&lang=ts"

import "./cwzb.vue?vue&type=style&index=0&id=7b6df4a3&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6df4a3"]])

export default __exports__